<template>
  <div class='pt-16' @click="handlePageClick" style="height:100%">
    <el-form ref="form">
      <el-space wrap>
        <el-form-item label="合约">
          <el-input v-model="obj.searchValue" placeholder="名称/代码 搜索合约" @input="handleInput" style="width: 250px"
            clearable>
            <template #prefix>
              <el-icon class="el-input__icon">
                <search />
              </el-icon>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="手数">
          <el-input-number v-model="obj.quantity" :min="1" :max="100" :precision="0" style="width:120px" />
        </el-form-item>
        <el-form-item label="价格">
          <!-- <el-input v-model="obj.price" :disabled="true" style="width:120px" /> -->
          <el-input v-model="obj.price"  style="width:120px" />
        </el-form-item>
        <el-form-item label="">
          <el-button type="danger" @click="openLong">多开</el-button>
        </el-form-item>
        <el-form-item label="">
          <el-button type="success" @click="openShort">空开</el-button>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="closeLong">平多</el-button>
        </el-form-item>
        <el-form-item label="">
          <el-button type="primary" @click="closeShort">平空</el-button>
        </el-form-item>
      </el-space>
    </el-form>
    <el-tag type="warning" size="small">模拟盘按现价即时成交</el-tag>
    <div style="width: 250px; max-height: 420px;" class='search-ul'>
      <div v-for="data in obj.filteredList" :key="data" class="search-li" @click="handleClick(data)">
        {{ data['name'] }} {{ data['symbol'] }} {{ data['exchange'] }}
        <span v-if="data['main'] === 1"> *主力 </span>
      </div>
    </div>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive } from "vue";
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { http, httpNoLoading } from "../util/http";
import { ElMessage } from 'element-plus'
import { isMarketTime } from '../util/base'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const store = useStore()
    const route = useRoute()
    const obj = reactive({
      searchList: [],
      filteredList: [],
      searchValue: '',
      searchSymbol: '',
      searchExchange: '',
      quantity: 1,
      price: 0,
      openClose: '',
      direction: '',
      timer: null,
    });

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      if (route.query.name != null) {
        obj.searchValue = route.query.name
        getLastPriceLoop()
      }
      renderSelect()
    });

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      window.clearInterval(obj.timer)
      vueEvent.off('event')
    })

    // 获取数据渲染下拉框
    const renderSelect = () => {
      let formData = new FormData()
      formData.append("category", "main_all")
      http({
        url: `/market`,
        method: 'post',
        data: formData
      }).then((res) => {
        obj.searchList = res.data.data
      })
    }

    // 搜索框输入事件
    const handleInput = () => {
      window.clearInterval(obj.timer) // 清除计时器
      // obj.price = 0 // 清除价格
      if (obj.searchValue.trim() === '') {
        obj.filteredList = []
        return
      }
      obj.filteredList = obj.searchList.filter(item => item['name'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()) ||
        item['symbol'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()))
    }

    // 搜索结果点击事件
    const handleClick = (data) => {
      obj.searchValue = data['name']
      obj.searchSymbol = data['symbol']
      obj.searchExchange = data['exchange']
      obj.filteredList = []
      getLastPriceLoop()
    }

    // 点击持仓数据传来name时的处理
    vueEvent.on('event', (name) => {
      console.log(name)
      obj.searchValue = name
      getLastPriceLoop()
    })

    // 不断获取最新行情数据
    const getLastPriceLoop = () => {
      window.clearInterval(obj.timer)
      getLastPrice()
      obj.timer = window.setInterval(function () {
        // 如不在开盘时间，则停止获取数据
        if (!isMarketTime()) {
          window.clearInterval(obj.timer)
          return
        }
        // 获取最新行情数据
        getLastPrice()
      }, 60000)
    }

    // 获取最新行情数据
    const getLastPrice = () => {
      let formData = new FormData()
      formData.append("name_list", obj.searchValue)
      httpNoLoading({
        url: `/ctp`,
        method: 'post',
        data: formData
      }).then((res) => {
        obj.price = res.data.data[0].close
      })
    }

    // 多开处理
    const openLong = () => {
      obj.openClose = 1
      obj.direction = 1
      submit()
    }

    // 空开处理
    const openShort = () => {
      obj.openClose = 1
      obj.direction = 0
      submit()
    }

    // 平多处理
    const closeLong = () => {
      obj.openClose = 0
      obj.direction = 1
      submit()
    }

    // 平空处理
    const closeShort = () => {
      obj.openClose = 0
      obj.direction = 0
      submit()
    }

    // 提交后台
    const submit = () => {
      if (!formCheck()) {
        return
      }
      let formData = new FormData()
      formData.append("name", obj.searchValue)
      formData.append("open_close", obj.openClose)
      formData.append("direction", obj.direction)
      formData.append("quantity", obj.quantity)
      formData.append("price", obj.price)
      http({
        url: `/trade`,
        method: 'post',
        data: formData
      }).then((res) => {
        ElMessage.success('操作成功')
        vueEvent.emit('updateBalanceEvent')
      })
    }

    // 表单check
    const formCheck = () => {
      if (obj.searchValue.trim() === '') {
        ElMessage.error('请输入合约名称')
        return false
      }
      if (!isMarketTime()) {
        ElMessage.error('当前时间未开盘')
        return false
      }
      return true
    }

    // 页面空白点击事件
    const handlePageClick = () => {
      obj.filteredList = []
    }

    return {
      obj,
      store,
      handleInput,
      handleClick,
      openLong,
      openShort,
      closeLong,
      closeShort,
      handlePageClick
    };
  },
};
</script>
<style lang="scss" scoped>
/* ================================
Components
Search
================================= */
.search-ul {
  position: absolute;
  left: 120px;
  top: 130px;
  z-index: 600;
  padding: 0;
  margin: 0;
  color: black;
  font-size: 14px;
  background: white;
  border-radius: 3px;
  list-style: none;
  -webkit-box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25),
    0 0 0 0px rgba(31, 31, 31, 0.15);
  box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25), 0 0 0 0px rgba(31, 31, 31, 0.15);
  -webkit-transition: opacity 100ms ease-out;
  transition: opacity 100ms ease-out;
  overflow: auto;
}

.search-li {
  text-align: left;
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  opacity: 0.8;
  height: 40px;
  line-height: 40px;
  padding: 0px 10px;
  border-bottom: 1px solid rgb(238, 238, 238);
}

.search-li:hover {
  background-color: #f5f5f5;
  color: rgb(89, 141, 252);
  border-radius: 3px;
  transition-property: color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}
</style>
